import styled from "styled-components";

import { Body } from "./styles";

interface IconTextProps {
  icon: any;
  text: string;
}

export const IconText: React.FC<IconTextProps> = ({ icon, text }) => {
  return (
    <IconTextContainer>
      <Circle $size={32} $backgroundColor="white">
        {!!icon ? icon : ""}
      </Circle>
      <Body>{text}</Body>
    </IconTextContainer>
  );
};

const IconTextContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const Circle = styled.div<{ $size: number; $backgroundColor: string }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${({ $size }) => $size}px;
  height: ${({ $size }) => $size}px;
  border-radius: 50%;
  background-color: ${({ $backgroundColor }) => $backgroundColor};
  color: rgb(232, 137, 80);
`;
